import okta from './okta'
import general from './general'
import modal from './modal'
import { combineReducers } from 'redux'

export default combineReducers({ okta, general, modal })